import React, { useState, useEffect } from "react";
import { styleSheet } from "./style";
import { withStyles } from "@mui/styles";
import { Box, Stack, Typography, Button } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getAgentPoints } from "../../../redux/agents/agentRosterDetail/points";
import TableSkeleton from "../../../components/loader/tableLoader.jsx";
import EastRoundedIcon from "@mui/icons-material/EastRounded";
import { useNavigate } from "react-router-dom";
import MessageIcon from "@mui/icons-material/Message";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import Skeleton from "@mui/material/Skeleton";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import EditNoteIcon from '@mui/icons-material/EditNote';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import CancelIcon from '@mui/icons-material/Cancel';
import LocalPostOfficeIcon from '@mui/icons-material/LocalPostOffice';
import SchoolIcon from '@mui/icons-material/School';
import ComputerIcon from '@mui/icons-material/Computer';
import GroupsIcon from '@mui/icons-material/Groups';
import AssessmentIcon from '@mui/icons-material/Assessment';
import DescriptionIcon from '@mui/icons-material/Description';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import WorkIcon from '@mui/icons-material/Work';
import CloseIcon from '@mui/icons-material/Close';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import MarkunreadMailboxIcon from '@mui/icons-material/MarkunreadMailbox';
import Tooltip from '@mui/material/Tooltip';

function getActivityIcon(type) {
  if (!type) return <MessageIcon sx={{ color: '#888' }} />;
  const t = (type + '').toLowerCase().replace(/[^a-z0-9]/g, '');
  if (t.includes('knowledgebasevideoviewed')) return <PlayArrowIcon sx={{ color: '#888' }} />;
  if (t.includes('callconnected')) return <PhoneIcon sx={{ color: '#888' }} />;
  if (t.includes('email')) return <EmailIcon sx={{ color: '#888' }} />;
  if (t.includes('textsent') || t.includes('textreplied')) return <MessageIcon sx={{ color: '#888' }} />;
  if (t.includes('offersubmitted')) return <AssignmentTurnedInIcon sx={{ color: '#888' }} />;
  if (t.includes('bindingcontractsigned')) return <EditNoteIcon sx={{ color: '#888' }} />;
  if (t.includes('transactionclosedwcompanylead')) return <BusinessCenterIcon sx={{ color: '#888' }} />;
  if (t.includes('transactionclosed')) return <WorkIcon sx={{ color: '#888' }} />;
  if (t.includes('contractterminated')) return (
    <Box sx={{ width: 36, height: 36, borderRadius: '50%', background: '#F5F5F5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Box sx={{ width: 20, height: 20, borderRadius: '50%', background: '#888', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CloseIcon sx={{ color: '#fff', fontSize: 15 }} />
      </Box>
    </Box>
  );
  if (t.includes('postcardsmailed')) return <MarkunreadMailboxIcon sx={{ color: '#888' }} />;
  if (t.includes('ceclasscompleted')) return <SchoolIcon sx={{ color: '#888' }} />;
  if (t.includes('attendmeetingtrainingvirtually')) return <ComputerIcon sx={{ color: '#888' }} />;
  if (t.includes('attendmeetingtraininginperson')) return <GroupsIcon sx={{ color: '#888' }} />;
  if (t.includes('sellercmarun')) return <AssessmentIcon sx={{ color: '#888' }} />;
  if (t.includes('listingagreementsigned')) return <DescriptionIcon sx={{ color: '#888' }} />;
  if (t.includes('holdopenhouse')) return <HomeWorkIcon sx={{ color: '#888' }} />;
  if (t.includes('withdrawn') || t.includes('expired') || t.includes('lostlisting')) return (
    <Box sx={{ width: 36, height: 36, borderRadius: '50%', background: '#F5F5F5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Box sx={{ width: 20, height: 20, borderRadius: '50%', background: '#888', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CloseIcon sx={{ color: '#fff', fontSize: 15 }} />
      </Box>
    </Box>
  );
  if (t.includes('newagentsourcedlead')) return <PersonAddIcon sx={{ color: '#888' }} />;
  return <MessageIcon sx={{ color: '#888' }} />;
}

function PointsHistory(props) {
  const [filters, setFilters] = useState({
    pageNumber: 1,
    pageSize: 5,
  });
  const [showAll, setShowAll] = useState(false);
  const navigate = useNavigate();
  let { classes, adminDetail } = props;
  const dispatch = useDispatch();
  const pointsData = useSelector(
    (state) => state.agentRoster.points.pointsData
  );

  useEffect(() => {
    if (adminDetail.id) {
      let startDate =
        moment().startOf("month").format().slice(0, 11) + "00:00:01";
      let endDate = moment().endOf("month").format().slice(0, 11) + "23:23:59";
      dispatch(
        getAgentPoints({
          user_id: adminDetail.id,
          startDate,
          endDate,
          ...filters,
        })
      );
    }
  }, [adminDetail.id]);

  const rows = pointsData.data || [];
  const visibleRows = showAll ? rows : rows.slice(0, 5);

  return (
    <Box>
      <Box className={classes.tableRoot}>
        <Box sx={{ px: 2, pb: 2 }}>
          {pointsData.isLoading ? (
            <Box>
              {[...Array(5)].map((_, idx) => (
                <Box
                  key={idx}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    borderRadius: '18px',
                    minHeight: 40,
                    p: 0.9,
                    pl: 1.75,
                    pr: 2.5,
                    mb: idx === 4 ? 0 : 1.25,
                    maxWidth: '100%',
                    overflow: 'hidden',
                    boxShadow: '0 4px 16px 0 rgba(0,0,0,0.08)',
                    background: '#fff',
                  }}
                >
                  <Skeleton variant="circular" width={36} height={36} sx={{ mr: 2.25 }} />
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Skeleton variant="text" width="60%" height={18} sx={{ mb: 0.5 }} />
                    <Skeleton variant="text" width="40%" height={15} />
                  </Box>
                  <Skeleton variant="rectangular" width={38} height={22} sx={{ borderRadius: '12px', ml: 2 }} />
                </Box>
              ))}
            </Box>
          ) : (
            visibleRows.map((row, idx) => (
              <Box
                key={row.id || idx}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: '18px',
                  minHeight: 40,
                  p: 0.9,
                  pl: 1.75,
                  pr: 2.5,
                  mb: idx === visibleRows.length - 1 ? 0 : 1.25,
                  maxWidth: '100%',
                  overflow: 'hidden',
                  boxShadow: '0 4px 16px 0 rgba(0,0,0,0.08)',
                  background: '#fff',
                }}
              >
                <Box sx={{ width: 36, height: 36, borderRadius: '50%', background: '#F5F5F5', display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 2.25 }}>
                  {getActivityIcon(row?.title || row?.action)}
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <Typography sx={{ fontWeight: 500, fontSize: 14, color: '#222', lineHeight: 1.1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'inline-flex', alignItems: 'center', position: 'relative', top: '1px' }}>
                      {row?.title || row?.action}
                    </Typography>
                  </Box>
                  {row?.description ? <Typography sx={{ fontSize: 14, color: '#444', mt: 0.5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', position: 'relative', top: '1px' }}>{row.description}</Typography> : null}
                </Box>
                <Box sx={{ minWidth: 48, textAlign: 'right', ml: 2, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center', height: '100%' }}>
                  {row.point === 0 ? (
                    <Tooltip title="Daily limit reached.">
                      <Typography sx={{ color: '#444', fontWeight: 600, fontSize: 18, textAlign: 'right', pr: 0, cursor: 'help' }}>–</Typography>
                    </Tooltip>
                  ) : (
                  <Typography sx={{ color: row.point > 0 ? '#00B906' : '#DA0000', fontWeight: 600, fontSize: 18, textAlign: 'right', pr: 0 }}>
                    {row.point > 0 ? '+' : ''}{row.point}
                  </Typography>
                  )}
                  <Typography sx={{ fontSize: 12.5, color: '#A4A4A4', mt: 0, textAlign: 'right', whiteSpace: 'nowrap' }}>{moment(row.createdAt).format('M/D/YY h:mm A')}</Typography>
                </Box>
              </Box>
            ))
          )}
          {!pointsData.isLoading && rows.length === 0 && (
            <Typography sx={{ color: '#BDBDBD', fontSize: 16, fontWeight: 500, textAlign: 'center', mt: 10, mb: 11 }}>
              No point activity yet!
            </Typography>
          )}
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3, mb: 0 }}>
            <Button
              variant="text"
              href="/dashboard/points"
              component="a"
              sx={{
                background: '#F7F7F7',
                borderRadius: '24px',
                fontWeight: 500,
                fontSize: 14,
                color: '#888',
                px: 5,
                py: 0.6,
                minHeight: 'unset',
                minWidth: 'unset',
                width: '100%',
                maxWidth: '100%',
                boxShadow: 'none',
                textTransform: 'none',
                '&:hover': { background: '#ececec' },
              }}
            >
              View More <EastRoundedIcon sx={{ fontSize: 18, ml: 1 }} />
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
export default withStyles(styleSheet, {
  name: "pointsHistoryStyle",
})(PointsHistory);
